export default {
    getProgressAnalysis: (state) => state.progressAnalysis,
  }